import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';
import withTrack from 'HOCs/withTrack/withTrack';
import Button from 'Components/Button/Button';
import css from './FollowButton.scss';
import { FormattedMessage as Translation } from 'react-intl';
import {
    getUserIsFollowing,
    followUser,
    unFollowUser,
    getFollowers,
    getFollowing
} from 'Actions/users';
import setToastMessageState from 'Actions/setToastMessageState';
import _setLoginModalState from 'Actions/setLoginModalState';
import {
    userFollowingSelector,
    isUserIsFollowingFetching,
    isUserFollowingFetching,
    isUserUnFollowingFetching
} from 'Selectors/users';
import withConfig from 'HOCs/withConfig/withConfig';
import IconWrapper from 'Components/IconWrapper/IconWrapper';
import { followProfile, unfollowProfile } from 'Constants/translations';
import { EXPIRATION } from 'Constants/constants';
import { PUBLIC_PROFILE_ICONS } from 'Constants/items';
import Auth from '../../../Auth';
import { SELECT_FROM_PROFILE } from 'Constants/tracking';

export class FollowButton extends React.Component {
    static propTypes = {
        isFetching: PropTypes.bool,
        following: PropTypes.bool,
        followUser: PropTypes.func.isRequired,
        unFollowUser: PropTypes.func.isRequired,
        getUserIsFollowing: PropTypes.func.isRequired,
        size: PropTypes.string,
        userId: PropTypes.string.isRequired,
        userName: PropTypes.string,
        track: PropTypes.func.isRequired,
        config: PropTypes.shape({
            get: PropTypes.func.isRequired
        }),
        isIconFlavour: PropTypes.bool,
        setToastMessageState: PropTypes.func,
        setLoginModalState: PropTypes.func,
        getFollowers: PropTypes.func,
        getFollowing: PropTypes.func,
        className: PropTypes.string
    };

    static defaultProps = {
        isFetching: false,
        size: 'normal'
    };

    constructor(props) {
        super(props);
        this.translationsValues = {
            name: this.props.userName
        };
    }
    componentDidMount() {
        const { getUserIsFollowing } = this.props;

        getUserIsFollowing();
    }

    componentDidUpdate = prevProps => {
        const { userId: prevUserId } = prevProps;
        const { userId, getUserIsFollowing } = this.props;

        if (prevUserId !== userId) {
            getUserIsFollowing();
        }
    }

    getTranslationById = id => {
        return <Translation id={ id } values={ this.translationsValues } />;
    }

    followAction = () => {
        const { isFetching, following, followUser, unFollowUser, getFollowers, getFollowing, track, userId } = this.props;

        getFollowers(userId);
        getFollowing(userId);
        if (isFetching) {
            return;
        }

        if (following) {
            this.props.setToastMessageState({ isOpen: true, message: this.getTranslationById(unfollowProfile), expiration: EXPIRATION });
            unFollowUser();
            track('social_tap_unfollow', {
                seller_id: userId,
                select_from: SELECT_FROM_PROFILE
            });
        }
        else {
            this.props.setToastMessageState({ isOpen: true, message: this.getTranslationById(followProfile), expiration: EXPIRATION });
            followUser();
            track('social_tap_follow', {
                seller_id: userId,
                select_from: SELECT_FROM_PROFILE
            });
        }
    }

    callFollowAction = () => {
        if (Auth.isLoggedIn()) {
            this.followAction();
        }
        else {
            // show login modal if user not already logged in
            this.props.setLoginModalState({
                state: true,
                redirectTo: '',
                entryPoint: 1,
                callback: this.followAction
            });
        }
    }

    render() {
        const { isFetching, following, size, isIconFlavour, className } = this.props;
        const followclassName = following ? css.inActiveIcon : css.activeIcon;

        if (isIconFlavour) {
            return (
                <div
                    className={ classNames(css.followIcon, { [css.followBackgroundClass]: following }) }
                    data-aut-id="iconFlavourButton"
                    onClick={ this.callFollowAction }
                >
                    <IconWrapper
                        icon={ following ? PUBLIC_PROFILE_ICONS.FOLLOWING_ACTIVE_PROFILE : PUBLIC_PROFILE_ICONS.FOLLOWING_INACTIVE_PROFILE }
                        size={ 28 }
                        className={ followclassName }
                    />
                </div>
            );
        }
        return (
            <Button
                className={ classNames(className) }
                type={ following ? 'outline' : 'primary' }
                disabled={ isFetching }
                fixed={ true }
                onClick={ this.callFollowAction }
                data-aut-id="followButton"
                size={ size }
            >
                { (following && !isFetching)
                    && <Translation id="following" />
                }
                { (!following && !isFetching)
                    && <Translation id="addFriend" />
                }
                { isFetching
                    && <Translation id="loading" />
                }
            </Button>
        );
    }
}

export const mapStateToProps = (state, ownProps) => {
    const { userId } = ownProps;

    return {
        isFetching: isUserFollowingFetching(state) || isUserUnFollowingFetching(state) || isUserIsFollowingFetching(state, userId),
        following: userFollowingSelector(state, userId)
    };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
    const { userId } = ownProps;

    return {
        getUserIsFollowing: () => dispatch(getUserIsFollowing(userId)),
        followUser: () => dispatch(followUser(userId)),
        unFollowUser: () => dispatch(unFollowUser(userId)),
        setToastMessageState: state => dispatch(setToastMessageState(state)),
        setLoginModalState: state => dispatch(_setLoginModalState(state)),
        getFollowers: userId => dispatch(getFollowers(userId)),
        getFollowing: userId => dispatch(getFollowing(userId))
    };
};

export default compose(
    withTrack,
    connect(mapStateToProps, mapDispatchToProps),
    withConfig
)(FollowButton);
